import React from 'react'
import historyImage from 'icons/history.png'
import fileEmptyImage from 'icons/file-empty.png'

const DUPLICATE_JOB_ILLUSTRATION_SRC = historyImage
const DAILY_JOB_LIMIT_ILLUSTRATION_SRC = fileEmptyImage

const illustrationClassName = 'h-[120px] w-[120px] shrink-0 object-contain'

export const DuplicateJobIllustration = () => (
  <img
    src={DUPLICATE_JOB_ILLUSTRATION_SRC}
    alt=""
    className={illustrationClassName}
    aria-hidden="true"
  />
)

export const DailyJobLimitIllustration = () => (
  <img
    src={DAILY_JOB_LIMIT_ILLUSTRATION_SRC}
    alt=""
    className={illustrationClassName}
    aria-hidden="true"
  />
)
